module.exports = __webpack_public_path__ + "img/logo.50a92f8d.svg";